module.exports = __webpack_public_path__ + "static/img/wisdomApply3.0ddd72c9.png";